document.addEventListener('DOMContentLoaded', function () {
  var rte = document.querySelector('.shopify-policy__body .rte');
  if (!rte) return;

  var text = rte.textContent.trim();
  if (!text || ['.', '!', '?'].includes(text.slice(-1))) return;

  var walker = document.createTreeWalker(rte, NodeFilter.SHOW_TEXT);
  var lastNode = null;
  var node;
  while ((node = walker.nextNode())) {
    if (node.textContent.trim()) lastNode = node;
  }
  if (lastNode) lastNode.textContent = lastNode.textContent.trimEnd() + '.';
});
